import { ConfigElement } from "../../_types";
import { ScreenProps } from '@components-common/types';
import { mapView } from "./view";
import { has, propOr } from "ramda";
import { mapToolbar } from "./toolbar";
import { mapForm } from "./form";
import { mapTable } from "./table";
import { TabbedPage } from '../../../components-common/tabs/TabbedPage';

const applyToPropOr = (defaultValue:any, propName:string, fn: any, obj:any) => {
  if(has(propName, obj)){
    return fn();
  }
  return defaultValue;
};

export const mapTabbedScreen = (config:ConfigElement, context: ScreenProps) => {
  context.type = "tabbed";
  const result = {
    type: "tabbed",
    view: {
      ...mapView(config,context),
      Component: TabbedPage,
      ...{props: {
        tabs: (config as any).tabs,
        components: [
          ...(propOr([], "children", config) as any),
          ...applyToPropOr([], "left", () => mapToolbar(config, context),config),
          ...applyToPropOr([], "form", () => mapForm(config as any, context),config),
          applyToPropOr([], "columns", () => mapTable(config, context),config),
          ...(propOr([], "components", config) as any),
        ]
      }}
    }
  };
  return result;
}
